/**
 * @generated SignedSource<<64da99bd55cf46ef1502fcbf0a421778>>
 * @relayHash 638a8927b678c956f62e66909b130468
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fddcba2c730fed863e19037f3b322032a2e6e9d261bc28033d24218f693a6d43

import type { ConcreteRequest } from 'relay-runtime';
export type AdminUnitLinkedResourceFilter = {
  atis?: ReadonlyArray<string> | null;
};
export type useUnitLinkedResourceIdsQuery$variables = {
  after?: string | null;
  anchorAri: string;
  filter?: AdminUnitLinkedResourceFilter | null;
  first?: number | null;
};
export type useUnitLinkedResourceIdsQuery$data = {
  readonly admin_unitLinkedResource: {
    readonly id: string;
    readonly links: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        } | null;
      }> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      };
    };
  } | null;
};
export type useUnitLinkedResourceIdsQuery = {
  response: useUnitLinkedResourceIdsQuery$data;
  variables: useUnitLinkedResourceIdsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "anchorAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "anchorAri"
      }
    ],
    "concreteType": "AdminUnitLinkedResource",
    "kind": "LinkedField",
    "name": "admin_unitLinkedResource",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          }
        ],
        "concreteType": "AdminUnitLinkedConnection",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
          {
            "concreteType": "AdminUnitLinkedEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AdminUnitLinkedTo",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUnitLinkedResourceIdsQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUnitLinkedResourceIdsQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "id": "fddcba2c730fed863e19037f3b322032a2e6e9d261bc28033d24218f693a6d43",
    "metadata": {},
    "name": "useUnitLinkedResourceIdsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "aa2b61565fa97898d0b012b6058e4937";

export default node;
